import { Phone, MessageSquare, MapPin, Clock, Mail, ExternalLink } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useLang } from "@/LanguageContext";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, GBP_URL, TOWNS } from "@/data/site";

export const Footer = () => {
  const { t, town } = useLang();
  return (
  <footer data-testid="site-footer" className="relative grain overflow-hidden pb-28 pt-20 md:pb-20 md:pt-28">
    <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-3">
        <div>
          <a href={`tel:${PHONE_TEL}`} data-testid="footer-phone-link" className="block">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-forge-soft">{t.footer.callOrText}</p>
            <p className="mt-2 font-head text-4xl font-black uppercase tracking-tight text-steel-50 transition-colors duration-200 hover:text-forge-light sm:text-5xl">
              {PHONE_DISPLAY}
            </p>
          </a>
          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href={`tel:${PHONE_TEL}`}
              data-testid="footer-call-btn"
              className="flex items-center gap-2 rounded-sm bg-forge px-6 py-3.5 font-head text-base font-bold uppercase tracking-wide text-white transition-colors duration-200 hover:bg-forge-light"
            >
              <Phone size={17} strokeWidth={2.4} /> {t.footer.tapCall}
            </a>
            <a
              href={`sms:${PHONE_TEL}`}
              data-testid="footer-text-btn"
              className="flex items-center gap-2 rounded-sm border border-steel-700 px-6 py-3.5 font-head text-base font-bold uppercase tracking-wide text-steel-50 transition-colors duration-200 hover:border-forge hover:text-forge-light"
            >
              <MessageSquare size={17} strokeWidth={2.4} /> {t.footer.tapText}
            </a>
          </div>
        </div>

        <div className="space-y-6">
          <div className="flex gap-3">
            <MapPin size={18} className="mt-1 shrink-0 text-forge" />
            <div>
              <h3 className="font-head text-lg font-bold uppercase tracking-wide text-steel-50">{t.footer.shop}</h3>
              <p className="mt-1 text-sm text-steel-400">{t.footer.shopVal}</p>
            </div>
          </div>
          <div className="flex gap-3">
            <Clock size={18} className="mt-1 shrink-0 text-forge" />
            <div>
              <h3 className="font-head text-lg font-bold uppercase tracking-wide text-steel-50">{t.footer.hours}</h3>
              <p className="mt-1 text-sm text-steel-400">{t.footer.hoursVal}</p>
            </div>
          </div>
          <div className="flex gap-3">
            <Mail size={18} className="mt-1 shrink-0 text-forge" />
            <div>
              <h3 className="font-head text-lg font-bold uppercase tracking-wide text-steel-50">{t.footer.email}</h3>
              <a
                href={`mailto:${EMAIL}`}
                data-testid="footer-email-link"
                className="mt-1 block break-all text-sm text-steel-400 transition-colors duration-200 hover:text-forge-light"
              >
                {EMAIL}
              </a>
            </div>
          </div>
          <a
            href={GBP_URL}
            target="_blank"
            rel="noreferrer noopener"
            data-testid="gbp-link"
            className="inline-flex items-center gap-2 font-head text-base font-bold uppercase tracking-wide text-steel-400 transition-colors duration-200 hover:text-forge-light"
          >
            {t.footer.google} <ExternalLink size={15} />
          </a>
        </div>

        <div>
          <h3 className="font-head text-lg font-bold uppercase tracking-wide text-steel-50">{t.footer.area}</h3>
          <p className="mt-3 text-sm leading-relaxed text-steel-400">{TOWNS.map(town).join(" · ")}</p>
        </div>
      </div>

      <div className="mt-16 flex flex-col gap-4 border-t border-steel-700 pt-8 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <Logo className="h-10 w-10" />
          <span className="font-head text-lg font-extrabold uppercase tracking-tight text-steel-50">
            RockinHwelding<span className="text-forge-light">.com</span>
          </span>
        </div>
        <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-steel-400">
          © {new Date().getFullYear()} RockinHwelding.com · Wade Hill · Firebaugh, CA
        </p>
      </div>
    </div>
  </footer>
  );
};
